import { useState } from 'react'
import { Modal } from './Modal'
import { Button } from './ui/button'
import { useJourneyTrigger } from '../hooks/useJourneyTrigger'
import type { BPlateView } from '../types'
import type { JourneyApi } from './PlateViewRenderer'

export function AddEventModal({ view, runInputs, journeyApi, onClose }: {
  view: BPlateView
  runInputs: Record<string, string>
  journeyApi: JourneyApi
  onClose: () => void
}) {
  const [values, setValues] = useState<Record<string, string>>({})
  const trigger = useJourneyTrigger(journeyApi)
  const fields = view.formFields ?? []

  const handleSubmit = () => {
    if (!view.preparationId) return
    trigger.run(view.preparationId, { ...runInputs, ...values })
  }

  if (trigger.status === 'completed') {
    return (
      <Modal title="Add Event" onClose={onClose}>
        <p className="text-sm text-emerald-600 text-center py-4">Event added.</p>
        <Button onClick={onClose} className="w-full">Close</Button>
      </Modal>
    )
  }

  return (
    <Modal title="Add Event" onClose={onClose}>
      <div className="space-y-3">
        {fields.map(field => (
          <div key={field.key}>
            <label className="block text-theme-xs font-medium text-slate-500 mb-1">{field.label}</label>
            <input
              type={field.inputType ?? 'text'}
              placeholder={field.placeholder}
              value={values[field.key] ?? ''}
              onChange={e => setValues(prev => ({ ...prev, [field.key]: e.target.value }))}
              className="field"
            />
          </div>
        ))}
        {trigger.error && <p className="text-xs text-red-500">{trigger.error}</p>}
        <Button onClick={handleSubmit} disabled={trigger.isBusy} loading={trigger.isBusy} className="w-full">
          {trigger.isBusy ? 'Saving…' : 'Add Event'}
        </Button>
      </div>
    </Modal>
  )
}
